import * as types from '../const/action.types';
import apiForm from '../api/ManageFormApi';
import { loadManageProcesses } from './api.manage.process.actions';

export function manageFormHasErrored(bool, message) {
    return {
        type: types.MANAGE_FORM_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function manageFormIsLoading(bool) {
    return {
        type: types.MANAGE_FORM_IS_LOADING,
        isLoading: bool,
    };
}

export function manageFormIsSaving(bool) {
    return {
        type: types.MANAGE_FORM_IS_SAVING,
        isSaving: bool,
    };
}

export function manageFormFetchDataSuccess(items) {
    return {
        type: types.MANAGE_FORM_FETCH_DATA,
        items,
    };
}

export function loadManageForm(process) {
    return async (dispatch) => {
        dispatch(manageFormIsLoading(true));
        dispatch(manageFormHasErrored(false, ''));
        dispatch(manageFormFetchDataSuccess({}));
        return apiForm
            .getForm(process)
            .then((response) => {
                dispatch(manageFormIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                console.log('manageFormFetchDataSuccess', items);
                dispatch(manageFormHasErrored(false, ''));
                dispatch(manageFormFetchDataSuccess(items));
            })
            .catch((error) => {
                dispatch(manageFormHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function findInTabs(tabs, codigo) {
    const result = tabs.reduce((r, child) => {
        if (child.codigo === codigo) {
            r = child.nombre;
        } else if (!r && child.hijos && child.hijos.lenght > 0) {
            r = findInTabs(child.hijos, codigo);
        }
        return r;
    }, undefined);
    return result;
}

export function update(manage_form) {
    return async (dispatch) => {
        dispatch(manageFormIsLoading(true));

        const rules = manage_form.rules.map((r) => {
            const acciones = r.accion.map((a) => {
                if (a.parametros && a.parametros.campo) {
                    a.parametros.campo.nombre = findInTabs(
                        manage_form.tabs,
                        a.parametros.campo.codigo,
                    );
                }
                return a;
            });
            const condiciones = r.condicion.map((a) => {
                if (a.parametros && a.parametros.campo) {
                    a.parametros.campo.nombre = findInTabs(
                        manage_form.tabs,
                        a.parametros.campo.codigo,
                    );
                }
                return a;
            });
            r.accion = acciones;
            r.condicion = condiciones;
            return r;
        });
        manage_form.rules = [...rules];
        console.log(manage_form);
        dispatch(manageFormFetchDataSuccess(manage_form));
        dispatch(manageFormIsLoading(false));
    };
}

export function updateFields(tabs, process, form) {
    return async (dispatch) => {
        dispatch(manageFormIsSaving(true));
        try {
            const response = await apiForm.updateForm(process, form, tabs);
            dispatch(manageFormIsSaving(false));
            dispatch(loadManageProcesses());
            return response;
        } catch (error) {
            dispatch(manageFormIsLoading(false));
            throw Error(error);
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.manage.form.actions.js